import { Button, Form, Input, Row, Col, InputNumber } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { InternshipCompetencesFormProps } from "./SubjectContentForm.types";
import i18n from "../../../i18n";

const { List, Item } = Form;

const SubjectCursContentForm = (props: InternshipCompetencesFormProps) => {
	const { t } = i18n;

	return (
		<List
			initialValue={props.initialValue}
			name={props.name}
			rules={props.rules}
		>
			{(fields, { add, remove }) => (
				<div className="flex flex-col pb-5">
					<div style={{display: "flex"}}>
						<label className="pb-5" style={{width: "10%", textAlign: "left"}}>
							<span style={{ color: "#ff4d4f" }}>*&nbsp;</span>
							<b>Capitolul</b>
						</label>
						<label className="pb-5" style={{width: "80%", textAlign: "left"}}>
							<span style={{ color: "#ff4d4f" }}>*&nbsp;</span>
							<b>Conținutul</b>
						</label>
						<label className="pb-5" style={{width: "10.5%", textAlign: "left"}}>
							<span style={{ color: "#ff4d4f" }}>*&nbsp;</span>
							<b>Nr. ore</b>
						</label>
					</div> 
					

					<div className="flex flex-col">
						{fields.map(({ key, name, ...restField }) => (
							<div className="flex items-start gap-2 border-b border-black" style={{marginBottom: "10px"}} key={key}>
								<div className="flex gap-x-2 flex-wrap" style={{display: "flex"}}>
									<Item
										{...restField}
										name={[name, "nrCrt"]}
										initialValue=""
										style={{width: "10%", marginBottom: "5px"}}
										rules={[
											{
												required: true,
												pattern: /^\d+$/,
												message: "Introduceți un număr valid pentru capitol"
											}
										]}
										validateTrigger={["onChange", "onBlur"]}
									>
										
										<InputNumber min={0} precision={0} style={{ width: "100%" }}
											disabled={props.disabled ?? false}
											placeholder={"Capitol (numeric)"}
										/>
									</Item>

									<Item
										{...restField}
										name={[name, "content"]}
										initialValue=""
										style={{width: "80%", marginBottom: "5px"}}
										rules={[
											{
												required: true,
												message: "Introduceți conținutul pentru acest capitol"
											}
										]}
										validateTrigger={["onChange", "onBlur"]}
									>
										<Input.TextArea
											disabled={props.disabled ?? false}
											placeholder={"Conținut"}
											autoSize={{ minRows: 1, maxRows: 6 }}
										/>
									</Item>

									<Item
										{...restField}
										name={[name, "hoursNumber"]}
										initialValue=""
										style={{width: "10%", marginBottom: "5px"}}
										rules={[
											{
												required: true,
												pattern: /^\d+(\.\d{1,2})?$/,
												message: "Introduceți un număr valid pentru ore"
											}
										]}
										validateTrigger={["onChange", "onBlur"]}
									>
										<InputNumber min={0} precision={1} style={{ width: "100%" }}
											disabled={props.disabled ?? false}
											placeholder={"Numar ore"}
										/>
									</Item>
									{fields.length > 1 && !props.disabled && (
										<MinusCircleOutlined style={{marginLeft: "10px", marginTop: "8px"}}
											className="mt-2"
											onClick={() => remove(name)}
										/>
									)}
								</div>

							</div>
						))}
					</div>

					{!props.disabled && (
						<div className="">
							<Button
								type="dashed"
								onClick={() => add()}
								icon={<PlusOutlined />}
							>
								Adauga continut
							</Button>
						</div>
					)}
				</div>
			)}
		</List>
	);
};

export default SubjectCursContentForm;
